import { render } from "./MessagingPage.vue?vue&type=template&id=76e8a69e"
import script from "./MessagingPage.vue?vue&type=script&lang=js"
export * from "./MessagingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__